import * as React from "react";
import { forwardRef } from "react";
const SvgCheckboxIndeterminate = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { x: 0.5, y: 0.5, width: 23, height: 23, rx: 3.5, stroke: "current", fill: "current" }), /* @__PURE__ */ React.createElement("path", { d: "M7 12H10H17", stroke: "current", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgCheckboxIndeterminate);
export default ForwardRef;
